import { PAGE_LIST_INFO } from './info'

export const DefaultPage = 'achieve'
export const AchievePage = 'achieve'
export const WfsPage = 'website-wfs'
export const tenant2 = 'website-tenant-2'
export const FdrPage = 'website-fdr'
export const FfnPage = 'website-ffn'
export const BillsPage = 'website-bills'

export const WEBSITES_LIST = [
  'website-wfs',
  'website-tenant-2',
  'website-fdr',
  'website-ffn',
  'website-bills',
]

export const PAGE_LIST = PAGE_LIST_INFO

export const WEBSITEFIELD_TO_HOST_MAP = {
  default: {
    host: 'https://www.achieve.com',
  },
  Achieve: {
    host: 'https://www.achieve.com',
  },
  'Weekly Financial Solutions': {
    websiteField: 'Weekly Financial Solutions',
    host: 'https://www.weeklyfinancialsolutions.com',
  },
  FDR: {
    websiteField: 'FDR',
    host: 'https://www.freedomdebtrelief.com',
  },
  'Freedom Debt Relief': {
    websiteField: 'Freedom Debt Relief',
    host: 'https://www.freedomdebtrelief.com',
  },
  'Freedom Financial Network': {
    websiteField: 'Freedom Financial Network',
    host: 'https://www.freedomfinancialnetwork.com',
  },
}

export const getPageContentTypes = (siteKey = null) => {
  return PAGE_LIST[siteKey ?? process.env.NEXT_PUBLIC_SITE_ENVIRONMENT] || PAGE_LIST.default
}
